export class MasterPlanFilters {
  id!: string;
  filterFieldId!: string;
  filterTypeId!: string;
  filterValue!: string;
  planContainerId!: string;
}
